import React, { useEffect, useState } from 'react'
import { useAuthState } from 'context'
import axios from 'axios'
import { Loader } from 'components/loader/loader'
import { updateUser } from 'context/actions'
import { useAuthDispatch } from 'context'
import { userLang } from 'components/utils'
import './ProfilePage.scss'
import { Formik, Form } from 'formik'
import { validationProfile } from 'components/forms/validation'
import { rebuildData, } from 'components/utils'
import { FormSelect } from 'components/inputs/selectField'
import { useTranslation } from 'react-i18next';
import { TimeMaskField } from 'components/inputs/timeMask';
import Photo from 'assets/images/photo-1.png'
import Photo2 from 'assets/images/photo-2.png'
import { TextField } from '../components/inputs/TextField';
import { DatePickerField } from '../components/inputs/datePicker';


import bg from 'assets/images/form-bg.png'
import maks from 'assets/images/mask.png'

export const ProfilePage = () => {
  const { userDetails, token } = useAuthState()
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true)
  const [countryList, setCountryList] = useState(null)
  const [date, setDate] = useState(userDetails?.birthday ? new Date(userDetails?.birthday) : null)
  const [passportCreated, setpassportCreated] = useState(userDetails?.passport?.create_date ? new Date(userDetails?.passport?.create_date) : null)
  const [passportExpire, setpassportExpire] = useState(userDetails?.passport?.expire_date ? new Date(userDetails?.passport?.expire_date) : null)
  const [arriveDate, setArriveDate] = useState(userDetails?.flight_schedules?.input?.date ? new Date(userDetails?.flight_schedules?.input?.date) : null)
  const [arriveTime, setArriveTime] = useState(userDetails?.flight_schedules?.input?.time)
  const [departureDate, setdepartureDate] = useState(userDetails?.flight_schedules?.exit?.date ? new Date(userDetails?.flight_schedules?.exit?.date) : null)
  const [departureTime, setdepartureTime] = useState(userDetails?.flight_schedules?.exit?.time)
  const [photo, setPhoto] = useState(userDetails?.photo?.path);
  const [passportPhoto, setPassportPhoto] = useState(userDetails?.passport?.passport_photo?.path);
  // const [selectedGender, setSelectedGender] = useState(null)
  const [country_id, setCountry_id] = useState('')
  const [citizenship_id, setCitizenship_id] = useState('')
  const handlePhotoChange = (e) => {
    setPhoto(URL.createObjectURL(e.target.files[0]));
    const data = new FormData()
    data.append('photo', e.target.files[0])
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    };
    axios
      .post(`${process.env.REACT_APP_BACKEND}/user/profile/update-image`, data, {
        headers: headers
      }).then((data) => {
        updateUser(dispatch, data.data.data).then(() => setLoading(false))
      })
  }
  const handlePassportPhotoChange = (e) => {
    setPassportPhoto(URL.createObjectURL(e.target.files[0]));
    const data = new FormData()
    data.append('passport', e.target.files[0])
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'multipart/form-data'
    };
    axios
      .post(`${process.env.REACT_APP_BACKEND}/user/profile/update-image`, data, {
        headers: headers
      }).then((data) => {
        updateUser(dispatch, data.data.data).then(() => setLoading(false))
      })
  }
  // const history = useHistory()
  const dispatch = useAuthDispatch();
  // const { token } = useAuthState()
  // const districtRef = useRef()
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_BACKEND}/list/country`)
      .then((data) => setCountryList(data.data))
  }, [])

  const lang = userLang().split('-')
  const getCountryOpt = () => {
    return countryList?.data?.map((e) => {
      if (lang.includes('ru')) {
        return { value: e.id, label: e.name }

      }
      return { value: e.id, label: `${e[`name_${lang[0]}`]}` }
    })
  }


  const gender = [
    { value: '0', label: t('female') }, { value: '1', label: t('male') },
  ]



  // const handleLogout = () => {
  //   logout(dispatch)
  //   history.push('/')
  // }

  useEffect(() => {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
    axios
      .get(`${process.env.REACT_APP_BACKEND}/user/profile`)
      .then((data) => {
        console.log(data)
        updateUser(dispatch, data.data.data).then(() => setLoading(false))
      })
  }, [token, dispatch])

  // useEffect(() => {
  //   scroll('#root')
  // }, [])


  const initialValues = {
    surname: userDetails?.surname,
    name: userDetails?.name,
    phone: userDetails?.phone,
    patronymic: userDetails?.patronymic,
    email: userDetails?.email,
    birthday: new Date(userDetails?.birthday),
    sex: gender[userDetails?.sex],
    country_id: { value: userDetails?.country?.id, label: `${lang.includes('ru') ? userDetails?.country[`name`] :  userDetails?.country[`name_${lang[0]}`]}`},
    citizenship_id: { value: userDetails?.citizenship?.id, label:`${lang.includes('ru') ? userDetails?.citizenship[`name`] :  userDetails?.citizenship[`name_${lang[0]}`]}`},
    passport: {
      number: userDetails?.passport?.number,
      create_date: new Date(userDetails?.passport?.create_date),
      expire_date: userDetails?.passport?.expire_date ? new Date(userDetails?.passport?.expire_date) : null,
    },
    job: {
      organisation_name: userDetails?.job?.organisation_name,
      position: userDetails?.job?.position,
      count_people: '',
    },
    flight_schedules: {
      input: {
        name: userDetails?.flight_schedules?.input?.name,
        date: userDetails?.flight_schedules?.input?.date ? new Date(userDetails?.flight_schedules?.input?.date) : null,
        time: userDetails?.flight_schedules?.input?.time,
      },
      exit: {
        name: userDetails?.flight_schedules?.exit?.name,
        date: userDetails?.flight_schedules?.exit?.date ? new Date(userDetails?.flight_schedules?.exit?.date) : null,
        time: userDetails?.flight_schedules?.exit?.time,
      }
    },
    food: userDetails.food,
    places_to_visit: {
      // 1: userDetails?.places_to_visit[0].checked,
      // 2: userDetails?.places_to_visit[1].checked,
      // 3: userDetails?.places_to_visit[2].checked,
      // 4: userDetails?.places_to_visit[3].checked
    }
  }

  const getStatus = () => {
    if (userDetails?.status === 'moderated') {
      return ['grey', t('moderated')]
    }
    if (userDetails?.status === 'approved') {
      return ['green', t('approved')]
    }
    if (userDetails?.status === 'rejected') {
      return ['red', t('rejected')]
    }
  }

  const isDisabled = userDetails.status !== 'rejected'
  if (loading) return <Loader />

  return (
    <section className="anketa">
      <div className="anketa__bg">
        <picture>
          <img src={bg} alt="" width={1920} height={2600} />
        </picture>
      </div>
      <div className='container'>
        <div className="anketa__wrap">
          <div className="anketa__mask">
            <picture>
              <img src={maks} alt="" width={256} height={256} />
            </picture>
          </div>

            <div className="modal__phone">
            <div className='profile__title__wrapper'>
              <h2 className="profile__title title">{t('login')}</h2>
              {/* <button className="btn btn_blue " onClick={handleLogout}>
                <span>{t('logout')}</span>
              </button> */}
            </div>
            <div className={`profile__status ${getStatus()[0]}`}>{getStatus()[1]}</div>
            <div className="modal__wrap">
              <Formik
                initialValues={{ ...initialValues }}
                validate={async (values) => {
                  return validationProfile(values, t)
                }}
                onSubmit={(values, { setFieldError, resetForm }) => {
                  const data = rebuildData(values)
                  data.append(`locale`, userLang())
                  data.append(`places_to_visit`, JSON.stringify(values.places_to_visit))
                  const headers = {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data'
                  };
                  axios
                    .post(`${process.env.REACT_APP_BACKEND}/user/profile`, data, {
                      headers: headers
                    }
                    )
                    .then((data) => {
                      if (data.status === 200) {
                        updateUser(dispatch, data.data.data)
                        resetForm()
                      }
                    })
                    .catch((e) => {
                      console.log(e.response)
                      const { errors } = e.response.data
                      Object.keys(errors).forEach((key) => {
                        setFieldError(key, errors[key])
                      })
                    })
                }}
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  setFieldValue,
                }) => (
                  <Form

                    className="authorization__form authorization__form_reg"
                    onSubmit={handleSubmit}
                  >
                    <div className="authorization__subtitle">{t('personalTitle')}</div>
                    <div className='authorization__personal'>
                      <div className="authorization__input-group triple">
                        <div className="authorization__input-block">
                          <TextField
                            name="surname"
                            error={touched.surname && errors.surname}
                            value={values.surname}
                            placeholder={t('surname')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="name"
                            error={touched.name && errors.name}
                            value={values.name}
                            placeholder={t('firstname')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="patronymic"
                            error={touched.patronymic && errors.patronymic}
                            value={values.patronymic}
                            placeholder={t('lastname')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>

                        <div className="authorization__input-group double">
                        <div className="authorization__input-block">
                          <DatePickerField
                            error={touched.birthday && errors.birthday}
                            value={date}
                            name="birthday"
                            onChange={setDate}
                            placeholder={t('birthday')}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="sex"
                            error={touched.sex && errors.sex}
                            value={values.sex}
                            placeholder={t('sex')}
                            component={FormSelect}
                            options={gender.map((e) => ({ value: e.value, label: e.label }))}
                            isDisabled={isDisabled}
                          />
                        </div>
                      </div>
                      </div>
                      <div className='authorization__photo'>
                        <label htmlFor='photo'>
                          <input disabled={isDisabled} hidden id='photo' name='photo' type="file" onChange={handlePhotoChange} />
                          <img src={photo ? photo : Photo} alt='photoImg' width={192} height={192} />
                        </label>
                        <span className="authorization__error">
                          {errors.photo && touched.photo && errors.photo}
                        </span>
                      </div>
                    </div>
                    <div className="authorization__subtitle">{t('contacts')}</div>
                    <div className='authorization__contact'>
                      <div className="authorization__input-group ">
                        <div className="authorization__input-block">
                          <TextField
                            name="country_id"
                            error={touched.country_id && errors.country_id}
                            value={country_id}
                            placeholder={t('residence')}
                            component={FormSelect}
                            options={getCountryOpt()}
                            isDisabled={isDisabled}
                            onChange={(e) => setCountry_id(e)}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="citizenship_id"
                            error={touched.citizenship_id && errors.citizenship_id}
                            value={citizenship_id}
                            placeholder={t('citizenship')}
                            component={FormSelect}
                            options={getCountryOpt()}
                            isDisabled={isDisabled}
                            onChange={(e) => setCitizenship_id(e)}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="phone"
                            error={touched.phone && errors.phone}
                            value={values.phone}
                            placeholder={t('phone')}
                            handleChange={(e) => setFieldValue('phone', e.target.value)}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TextField
                            name="email"
                            error={touched.email && errors.email}
                            value={values.email}
                            placeholder={t('email')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="authorization__subtitle">{t('passport')}</div>
                    <div className='authorization__personal'>
                      <div className="authorization__input-group triple">
                        <div className="authorization__input-block">
                          <TextField
                            name="passport.number"
                            error={touched.passport?.number && errors.passport?.number}
                            value={values.passport?.number}
                            placeholder={t('passportNumber')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <DatePickerField
                            error={touched.create_date && errors.create_date}
                            value={passportCreated}
                            name="passport.create_date"
                            onChange={setpassportCreated}
                            placeholder={t('passportCreated')}
                            isDisabled={isDisabled}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <DatePickerField
                            error={touched.expire_date && errors.expire_date}
                            value={passportExpire}
                            name="passport.expire_date"
                            onChange={setpassportExpire}
                            placeholder={t('passportExpired')}
                            isDisabled={isDisabled}
                          />
                        </div>
                      </div>
                      <div className='authorization__photo'>
                        <label htmlFor='passportPhoto'>
                          <input disabled={isDisabled} hidden id='passportPhoto' name='passportPhoto' type="file" onChange={handlePassportPhotoChange} />
                          <img src={passportPhoto ? passportPhoto : Photo2} alt='pasportImg' width={192} height={192} />
                        </label>
                      </div>
                    </div>
                    <div className="authorization__subtitle">{t('job')}</div>
                    <div className='authorization__job'>
                      <div className="authorization__input-group">
                        <div className="authorization__input-block">
                          <TextField
                            name="job.organisation_name"
                            error={touched.job?.organisation_name && errors.job?.organisation_name}
                            value={values.job?.organisation_name}
                            placeholder={t('organization')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                      </div>
                      <div className="authorization__input-group ">
                        <div className="authorization__input-block">
                          <TextField
                            name="job.position"
                            error={touched.job?.position && errors.job?.position}
                            value={values.job?.position}
                            placeholder={t('position')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="authorization__subtitle">{t('transport')}</div>
                    <div className='authorization__transport'>
                      <div className="authorization__input-group ">
                        <div className="authorization__input-block">
                          <TextField
                            name="flight_schedules.input.name"
                            error={touched.flight_schedules?.input?.name && errors.flight_schedules?.input?.name}
                            value={values.flight_schedules?.input?.name}
                            placeholder={t('arrival')}
                            isDisabled={isDisabled}
                            handleChange={handleChange}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <DatePickerField
                            error={touched.flight_schedules?.input?.date && errors.flight_schedules?.input?.date}
                            value={arriveDate}
                            name="flight_schedules.input.date"
                            onChange={setArriveDate}
                            isDisabled={isDisabled}
                            placeholder={t('arrivalDate')}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TimeMaskField
                            error={touched.flight_schedules?.input?.time && errors.flight_schedules?.input?.time}
                            onChange={setArriveTime}
                            value={arriveTime}
                            name="flight_schedules.input.time"
                            isDisabled={isDisabled}
                            placeholder={t('arrivalTime')}
                          />
                        </div>
                      </div>
                      <div className="authorization__input-group ">
                        <div className="authorization__input-block">
                          <TextField
                            name="flight_schedules.exit.name"
                            error={touched.flight_schedules?.exit?.name && errors.flight_schedules?.exit?.name}
                            value={values.flight_schedules?.exit?.name}
                            placeholder={t('departure')}
                            isDisabled={isDisabled}
                            handleChange={handleChange}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <DatePickerField
                            error={touched.flight_schedules?.exit?.date && errors.flight_schedules?.exit?.date}
                            value={departureDate}
                            name="flight_schedules.exit.date"
                            onChange={setdepartureDate}
                            isDisabled={isDisabled}
                            placeholder={t('departureDate')}
                          />
                        </div>
                        <div className="authorization__input-block">
                          <TimeMaskField
                            error={touched.flight_schedules?.exit?.time && errors.flight_schedules?.exit?.time}
                            onChange={setdepartureTime}
                            value={departureTime}
                            name="flight_schedules.exit.time"
                            isDisabled={isDisabled}
                            placeholder={t('departureTime')}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="authorization__subtitle">{t('food')}</div>
                    <div className='authorization__food'>
                      <div className="authorization__input-group ">
                        <div className="authorization__input-block">
                          <TextField
                            error={touched.food && errors.food}
                            value={values.food}
                            name="food"
                            placeholder={t('foodText')}
                            handleChange={handleChange}
                            isDisabled={isDisabled}
                            component="textarea"
                          />
                        </div>
                      </div>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
